<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
    width="600px"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="125px" label-suffix="：">
      <el-form-item label="标题" prop="name">
        <el-input v-model="form.name" placeholder="请输入标题" v-trim/>
      </el-form-item>
      <el-form-item label="展示图片" prop="imgfullurl">
        <UploadAvatarImage
          :file="{ 'imgurlfull': form.imgfullurl, 'imgurl': form.imgurl }"
          :uploadData="uploadData" tipsLabel="" @uploadSuccess="uploadOutSuccess" @uploadEnd="isUploading=false"
          @uploadBegin="isUploading=true" />
      </el-form-item>
      <el-form-item label="排序码（升序）" prop="sortnum">
        <el-input v-model="form.sortnum" placeholder="请输入排序码（升序）" v-trim/>
      </el-form-item>
      <!-- <el-form-item label="编辑时间" prop="editDate">
        <el-date-picker v-model="form.editDate" value-format="yyyy-MM-dd" placeholder="请输入编辑时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="编辑人" prop="editor">
        <el-input v-model="form.editor" placeholder="请输入编辑人" v-trim/>
      </el-form-item>
      <el-form-item label="是否已删除 0未删除 1已删除" prop="isdeleted">
        <el-input v-model="form.isdeleted" placeholder="请输入是否已删除 0未删除 1已删除" v-trim/>
      </el-form-item>
      <el-form-item label="类型 0图文 1外链 2其他" prop="type">
        <el-input v-model="form.type" placeholder="请输入类型 0图文 1外链 2其他" v-trim/>
      </el-form-item>
      <el-form-item label="状态 0启用 1禁用" prop="status">
        <el-input v-model="form.status" placeholder="请输入状态 0启用 1禁用" v-trim/>
      </el-form-item>
      <el-form-item label="备注" prop="info">
        <el-input v-model="form.info" placeholder="请输入备注" v-trim/>
      </el-form-item>
      <el-form-item label="内容" prop="content">
        <el-input v-model="form.content" placeholder="请输入内容" v-trim/>
      </el-form-item> -->

    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import UploadAvatarImage from '@/components/common/UploadAvatarImage.vue'
export default {
  name: 'OperaAdWindow',
  extends: BaseOpera,
  components: { GlobalWindow, UploadAvatarImage },
  data () {
    return {
      isUploading: false,
      uploadData: {folder: 'bike'},
      // 表单数据
      form: {
        id: null,
        name: '',
        sortnum: '',
        imgfullurl: '',
        imgurl: ''
      },
      // 验证规则
      rules: {
        imgfullurl: [
          { required: true, message:'请上传展示图片', tigger:'change' }
        ]
      }
    }
  },
  created () {
    this.config({
      api: '/business/ad',
      'field.id': 'id'
    })
  },
  methods: {
    open (title, target) {
      this.title = title
      this.visible = true
      // 新建
      if (target == null) {
        this.$nextTick(() => {
          this.$refs.form.resetFields()
          this.form[this.configData['field.id']] = null
          this.form.imgurl = ''
        })
        return
      }
      // 编辑
      this.$nextTick(() => {
        for (const key in this.form) {
          this.form[key] = target[key]
        }
      })
    },
    uploadOutSuccess(file) {
      this.form.imgurl = file.imgurl;
      this.form.imgfullurl = file.imgurlfull;
    },
  },
}
/**
 *
 */
</script>
